import { TipoSezione } from '../tipologiche/tipo-sezione';

export class SpostaDocumentoRequest {
    idDocumento: string;
    idFascicolo: string;
    idEntita: string;
    tipoSezioneSorgente: TipoSezione;
    tipoSezioneDestinazione: TipoSezione;
}
